import { IVacancyPicture } from '../../../vacancy';
import { VacancyPictureDto } from '../../../vacancy/dto/vacancy-picture.dto';
import { AttachmentDto } from '../../attachment';

/**
 * Builds picture related objects.
 */
export class VacancyPictureFactory {
  /**
   * Accepts a picture object and returns a VacancyPictureDto object
   * @param picture
   * @returns
   */
  static toDto(vacancyPicture: IVacancyPicture): VacancyPictureDto {
    const id = vacancyPicture?.picture?.id;
    const attachment = vacancyPicture?.picture?.attachment as AttachmentDto;
    const edited = vacancyPicture?.picture?.edited! as AttachmentDto;
    const thumbnail = vacancyPicture?.picture?.thumbnail! as AttachmentDto;
    const order = vacancyPicture.order!;
    const left = vacancyPicture.picture.left;
    const top = vacancyPicture.picture.top;
    const width = vacancyPicture.picture.width;
    const height = vacancyPicture.picture.height;
    const rotationAngle = vacancyPicture.picture.rotationAngle;
    const flipHorizontal = vacancyPicture.picture.flipHorizontal;
    const flipVertical = vacancyPicture.picture.flipVertical;
    const zoom = vacancyPicture.picture.zoom;
    return {
      id,
      attachment,
      edited,
      thumbnail,
      order,
      left,
      top,
      width,
      height,
      rotationAngle,
      flipHorizontal,
      flipVertical,
      zoom,
    };
  }

  /**
   * Accepts a VacancyPictureDto object and returns a picture object
   * @param picture
   * @returns
   */
  static fromDto(dto: VacancyPictureDto): IVacancyPicture {
    const id = dto.id!;
    const attachment = dto.attachment!;
    const edited = dto.edited!;
    const thumbnail = dto.thumbnail!;
    const order = dto.order!;
    const left = dto.left;
    const top = dto.top;
    const width = dto.width;
    const height = dto.height;
    const rotationAngle = dto.rotationAngle;
    const flipHorizontal = dto.flipHorizontal;
    const flipVertical = dto.flipVertical;
    const zoom = dto.zoom;
    return {
      picture: {
        id,
        attachment,
        edited,
        thumbnail,
        left,
        top,
        width,
        height,
        rotationAngle,
        flipHorizontal,
        flipVertical,
        zoom,
      },
      order,
    };
  }
}
